import React from "react";
import { FaUser } from "react-icons/fa";
import { ToggleSwitch } from "../../UI/DesignStandards";

const BowlerSidepotSelection = ({
  bowler,
  index,
  sidepotEvents,
  selectedSidepots,
  onSidepotToggle,
  getBowlerSidepotCount,
  formatCurrency,
}) => {
  const bowlerSidepotCost = sidepotEvents.reduce((total, sidepot) => {
    const isSelected = selectedSidepots[bowler.name]?.[sidepot.id] || false;
    return total + (isSelected ? sidepot.entryFee || 0 : 0);
  }, 0);

  return (
    <div className="border border-gray-200 rounded-lg p-4">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center">
          <FaUser className="w-5 h-5 text-brand-muted mr-3" />
          <div>
            <h3 className="font-semibold text-gray-900">{bowler.name}</h3>
            <p className="text-sm text-gray-600">
              {index === 0 ? "Primary Bowler" : "Teammate"}
            </p>
          </div>
        </div>
        <div className="text-right">
          <div className="text-sm text-gray-500">
            {getBowlerSidepotCount(bowler.name)} selected
          </div>
          <div className="text-sm font-medium text-brand-charcoal">
            {formatCurrency(bowlerSidepotCost)}
          </div>
        </div>
      </div>

      <div className="grid gap-3">
        {sidepotEvents.map((sidepot) => (
          <div
            key={sidepot.id}
            className="flex items-center justify-between p-3 bg-brand-cream rounded-lg"
          >
            <div className="flex items-center">
              <ToggleSwitch
                checked={selectedSidepots[bowler.name]?.[sidepot.id] || false}
                onChange={(checked) =>
                  onSidepotToggle(bowler.name, sidepot.id, checked)
                }
                className="mr-3"
              />
              <div>
                <div className="font-medium text-gray-900">
                  {sidepot.eventName}
                </div>
                <div className="text-sm text-gray-600">
                  {sidepot.eventDescription}
                </div>
              </div>
            </div>
            <div className="text-right">
              <div className="font-semibold text-brand-charcoal">
                {formatCurrency(sidepot.entryFee)}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BowlerSidepotSelection;
